import { ChevronRight } from 'lucide-react';
import { StatusPill } from './StatusPill';
import { answerText, formatDate } from './adminApi';

const Empty = ({ filtered }) => <div className="admin-empty-state" data-testid="admin-empty-state">
  <h3>{filtered ? 'No matching submissions' : 'No submissions yet'}</h3>
  <p>{filtered ? 'Try clearing the filters or widening the date range.' : 'New intake form briefs will appear here as soon as they come in.'}</p>
</div>;

const Skeletons = () => <div data-testid="admin-loading-skeleton">{[...Array(6)].map((_, i) => <div className="admin-skeleton" key={i} />)}</div>;

export const SubmissionsList = ({ items, loading, filtered, openId, onOpen, onStatusChange }) => {
  const rows = items || [];
  return <>
    <div className="admin-list" data-testid="admin-table">
      <div className="admin-thead"><span>Date</span><span>Name</span><span>Company</span><span>Industry</span><span>Primary interest</span><span>Status</span><span /></div>
      {loading ? <Skeletons /> : rows.length ? rows.map(entry => (
        <div key={entry.id} className={`admin-trow ${openId === entry.id ? 'is-open' : ''}`} data-testid={`admin-row-${entry.id}`}>
          <button type="button" className="admin-cell-main" onClick={() => onOpen(entry)} data-testid={`admin-row-date-${entry.id}`}><span>{formatDate(entry.created_at)}</span></button>
          <button type="button" className="admin-cell-main" onClick={() => onOpen(entry)}><strong>{answerText(entry.answers.contactName) || '—'}</strong></button>
          <button type="button" className="admin-cell-main" onClick={() => onOpen(entry)}><span>{answerText(entry.answers.companyName) || '—'}</span></button>
          <button type="button" className="admin-cell-main" onClick={() => onOpen(entry)}><span>{answerText(entry.answers.industry) || '—'}</span></button>
          <button type="button" className="admin-cell-main" onClick={() => onOpen(entry)}><span>{answerText(entry.answers.primaryGoal) || '—'}</span></button>
          <StatusPill status={entry.status} id={entry.id} onChange={value => onStatusChange(entry, value)} />
          <button type="button" className="admin-row-menu" onClick={() => onOpen(entry)} aria-label={`Open ${answerText(entry.answers.companyName)} submission`} data-testid={`admin-row-open-${entry.id}`}><ChevronRight size={16} /></button>
        </div>
      )) : <Empty filtered={filtered} />}
    </div>

    <div className="admin-cardlist" data-testid="admin-cardlist">
      {loading ? <Skeletons /> : rows.length ? rows.map(entry => (
        <div className="admin-entry-card" key={entry.id} role="button" tabIndex={0} onClick={() => onOpen(entry)}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(entry); } }}
          data-testid={`admin-card-${entry.id}`}>
          <h3>{answerText(entry.answers.contactName) || '—'}</h3>
          <p>{answerText(entry.answers.companyName) || '—'}{entry.answers.industry ? ` · ${answerText(entry.answers.industry)}` : ''}</p>
          <div className="admin-entry-card-foot">
            <StatusPill status={entry.status} id={entry.id} onChange={value => onStatusChange(entry, value)} />
            <small>{formatDate(entry.created_at)}</small>
          </div>
        </div>
      )) : <Empty filtered={filtered} />}
    </div>
  </>;
};
